import { ImageCard } from './ImageCard';
import { isList } from '../../hoc';
import { CardPanel } from '../../Panels';

export const ImageCardList = isList(CardPanel)(ImageCard);

export default ImageCardList;